"use client"

import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import CKEditorWrapper from "@/lib/config/lib/CkeditorWrapper"
import { ComponentConfig } from "@measured/puck"
import { RenderConfig } from "./RenderConfig"
import type { SupplierGridItem, SupplierGridProps } from "./types"

const CF = "https://d300nzfp1n1jsy.cloudfront.net/uploads"

export const SupplierGrid: ComponentConfig<SupplierGridProps> = {
  label: "Tamda Foods | Supplier Grid",
  fields: {
    items: {
      label: "Items",
      type: "array",
      getItemSummary: (item: SupplierGridItem, index = 0) => item?.title || `Item ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: (props: any) => <MediaSelect {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        description: {
          label: "Description",
          type: "custom",
          render: ({ value, onChange }: any) => <CKEditorWrapper value={value} onChange={onChange} />,
        },
        contact: {
          label: "Contact",
          type: "custom",
          render: ({ value, onChange }: any) => <CKEditorWrapper value={value} onChange={onChange} />,
        },
      },
    },
  },
  defaultProps: {
    items: [
      {
        image: `${CF}/0_C2_A4932_32b34f74bd_d9be066054.webp`,
        title: "Hợp tác cùng TDF",
        description:
          "Sản phẩm của bạn hấp dẫn và bạn muốn hợp tác cùng Tamda Foods? Liên hệ với chúng tôi qua email dưới đây.",
        contact:
          '<a href="mailto:info@tamda.eu">info@tamda.eu</a> | <a href="mailto:nakup@tamda.eu">nakup@tamda.eu</a>',
      },
      {
        image: `${CF}/Rectangle_1117_1439f7ec12_6cdd337afd.webp`,
        title: "Dịch vụ giao hàng RDE",
        description:
          'Bạn có nhu cầu nhập hàng nhưng không có thời gian đến trực tiếp cửa hàng? Hãy truy cập link <a target="_blank" rel="noopener noreferrer" href="https://www.tamdaexpres.eu">www.tamdaexpres.eu</a> để đặt hàng hoặc liên hệ với chúng tôi qua hotline dưới đây.',
        contact:
          '<a href="tel:420210323888">+420 210 323 888</a> | <a href="mailto:hostivice@tamda.eu">hostivice@tamda.eu</a>',
      },
      {
        image: `${CF}/S4_A5448_f9de972fdc_f8b31663db.webp`,
        title: "Quảng cáo trên TDF",
        description:
          "Bạn có muốn hợp tác cùng Tamda để quảng bá sản phẩm của bạn? Hãy liên hệ với chung tôi qua email dưới đây.",
        contact: '<a href="mailto:marketing@tamda.eu">marketing@tamda.eu</a>',
      },
      {
        image: `${CF}/Rectangle_1118_125d17ac4d_1d081d2704.png`,
        title: "Giải pháp kỹ thuật",
        description:
          "Bạn có các giải pháp kỹ thuật giúp hỗ trợ tốt cho công việc? Hãy liên hệ với chúng tôi",
        contact: '<a href="mailto:pkt@tamda.eu">pkt@tamda.eu</a>',
      },
    ],
  },
  ...RenderConfig,
}
